import { TextInput } from '@kcftech/design-system';
import { AssetCategoryParameterType } from '@kcftech/prometheus-client';
import { defaultValueMaxLength } from 'pages/Settings/AssetType/parameter_form/shared';
import {
    AssetParameterFormData,
    AssetParameterFormInputProps,
} from 'pages/Settings/AssetType/parameter_form/types';
import { useEffect } from 'react';
import { RegisterOptions, useFormState } from 'react-hook-form';

const defaultValueRules: RegisterOptions<AssetParameterFormData, 'defaultValue'> = {
    maxLength: {
        value: defaultValueMaxLength,
        message: `Default Value cannot exceed ${defaultValueMaxLength} characters`,
    },
    validate: () => undefined,
};

export function AssetParameterTextFormContent({
    form,
    parameter,
}: AssetParameterFormInputProps) {
    const {
        register,
        setValue,
        watch,
        control,
    } = form;

    const {
        errors,
    } = useFormState({
        control,
    });

    const type = watch('type');

    useEffect(() => {
        if (type !== AssetCategoryParameterType.Text) {
            throw new Error('Invalid type');
        }

        if (parameter?.CategoryParameterType === AssetCategoryParameterType.Text) {
            setValue('defaultValue', parameter.DefaultValue ?? '');
        } else {
            setValue('defaultValue', '');
        }

        return () => {
            setValue('defaultValue', '');
        };
    }, [parameter?.CategoryParameterType, parameter?.DefaultValue, setValue, type]);

    return (
        <TextInput
            type="text"
            label="Default Value"
            placeholder="Enter a default value"
            error={errors.defaultValue?.message}
            {...register('defaultValue', defaultValueRules)}
        />
    );
}
